// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgVacationUnique24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_4564_301558)">
					<path
						d="M6.77002 9.33006L7.34002 7.25006L8.95002 5.42006L10.93 4.58006L13.52 4.31006L15.54 4.93006L16.82 6.17006L17.82 7.65006L18.32 9.22006L16.5 9.08006L14.64 9.49006L12.54 8.87006L10.7 9.70006L8.52002 9.01006L6.77002 9.33006Z"
						fill="#FF0000"
					/>
					<path
						d="M21.57 18.1H2.43C2.19 18.1 2 17.91 2 17.67C2 17.43 2.19 17.24 2.43 17.24H21.57C21.81 17.24 22 17.43 22 17.67C22 17.91 21.81 18.1 21.57 18.1Z"
						fill="black"
					/>
					<path
						d="M18.7701 19.82H6.30012C6.06012 19.82 5.87012 19.63 5.87012 19.39C5.87012 19.15 6.06012 18.96 6.30012 18.96H18.7801C19.0201 18.96 19.2101 19.15 19.2101 19.39C19.2101 19.63 19.0201 19.82 18.7801 19.82H18.7701Z"
						fill="black"
					/>
					<path
						d="M12.5399 13.27C12.3199 13.27 12.1499 13.09 12.1499 12.88V8.93004C12.1499 8.71004 12.3299 8.54004 12.5399 8.54004C12.7499 8.54004 12.9299 8.72004 12.9299 8.93004V12.88C12.9299 13.1 12.7499 13.27 12.5399 13.27Z"
						fill="black"
					/>
					<path
						d="M18.46 10.5C18.24 10.5 18.07 10.32 18.07 10.11C18.07 9.74004 17.39 9.32004 16.49 9.32004C15.59 9.32004 14.91 9.74004 14.91 10.11C14.91 10.33 14.73 10.5 14.52 10.5C14.31 10.5 14.13 10.32 14.13 10.11C14.13 9.74004 13.45 9.32004 12.55 9.32004C11.65 9.32004 10.97 9.74004 10.97 10.11C10.97 10.33 10.79 10.5 10.58 10.5C10.37 10.5 10.19 10.32 10.19 10.11C10.19 9.74004 9.51 9.32004 8.61 9.32004C7.71 9.32004 7.03 9.74004 7.03 10.11C7.03 10.33 6.85 10.5 6.64 10.5C6.43 10.5 6.25 10.32 6.25 10.11C6.25 6.63004 9.08 3.79004 12.57 3.79004C16.05 3.79004 18.89 6.62004 18.89 10.11C18.89 10.33 18.71 10.5 18.5 10.5H18.46ZM12.54 8.53004C13.37 8.53004 14.09 8.80004 14.51 9.22004C14.93 8.80004 15.65 8.53004 16.48 8.53004C17.02 8.53004 17.52 8.65004 17.91 8.84004C17.34 6.40004 15.14 4.58004 12.53 4.58004C9.92 4.58004 7.72 6.40004 7.15 8.84004C7.55 8.64004 8.04 8.53004 8.58 8.53004C9.41 8.53004 10.13 8.80004 10.55 9.22004C10.97 8.80004 11.69 8.53004 12.52 8.53004H12.54Z"
						fill="black"
					/>
					<path
						d="M10.5599 10.5001C10.3399 10.5001 10.1699 10.3201 10.1699 10.1101C10.1699 6.04011 12.1799 3.99011 12.2599 3.91011C12.4099 3.76011 12.6599 3.76011 12.8199 3.91011C12.9799 4.06011 12.9699 4.31011 12.8199 4.47011C12.7999 4.50011 10.9599 6.40011 10.9599 10.1201C10.9599 10.3401 10.7799 10.5101 10.5699 10.5101L10.5599 10.5001Z"
						fill="black"
					/>
					<path
						d="M14.51 10.5001C14.29 10.5001 14.12 10.3201 14.12 10.1101C14.12 6.3901 12.28 4.4801 12.26 4.4601C12.11 4.3101 12.11 4.0601 12.26 3.9001C12.41 3.7501 12.66 3.7501 12.82 3.9001C12.91 3.9901 14.91 6.0401 14.91 10.1001C14.91 10.3201 14.73 10.4901 14.52 10.4901L14.51 10.5001Z"
						fill="black"
					/>
					<path
						d="M12.5399 4.58C12.3199 4.58 12.1499 4.4 12.1499 4.19V3.39C12.1499 3.17 12.3299 3 12.5399 3C12.7499 3 12.9299 3.18 12.9299 3.39V4.18C12.9299 4.4 12.7499 4.57 12.5399 4.57V4.58Z"
						fill="black"
					/>
					<path
						d="M5.01002 18.1C4.90002 18.1 4.79002 18.06 4.71002 17.97C4.54002 17.8 4.54002 17.53 4.71002 17.36L6.43002 15.64C6.60002 15.47 6.87002 15.47 7.04002 15.64C7.21002 15.81 7.21002 16.08 7.04002 16.25L5.32002 17.97C5.24002 18.05 5.13002 18.1 5.02002 18.1H5.01002Z"
						fill="black"
					/>
					<path
						d="M17.0501 18.1C16.9401 18.1 16.8301 18.06 16.7501 17.97L15.0301 16.25C14.8601 16.08 14.8601 15.81 15.0301 15.64C15.2001 15.47 15.4701 15.47 15.6401 15.64L17.3601 17.36C17.5301 17.53 17.5301 17.8 17.3601 17.97C17.2801 18.05 17.1701 18.1 17.0601 18.1H17.0501Z"
						fill="black"
					/>
					<path
						d="M19.6299 16.38H5.86994C5.75994 16.38 5.64994 16.33 5.56994 16.25L2.12994 12.82C1.95994 12.65 1.95994 12.38 2.12994 12.21L3.41994 10.92C3.58994 10.75 3.85994 10.75 4.02994 10.92L6.90994 13.8H19.6299C19.8699 13.8 20.0599 13.99 20.0599 14.23V15.95C20.0599 16.19 19.8699 16.38 19.6299 16.38ZM6.04994 15.52H19.1999V14.66H6.72994C6.61994 14.66 6.50994 14.61 6.42994 14.53L3.71994 11.82L3.03994 12.5L6.04994 15.51V15.52Z"
						fill="black"
					/>
				</g>
				<defs>
					<clipPath id="clip0_4564_301558">
						<rect width={20} height={16.82} fill="white" transform="translate(2 3)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgVacationUnique24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgVacationUnique24;
